export default __webpack_public_path__ + "static/media/Confirmation.45cd4e1d.mp3";